<!-- 导航菜单 -->
<template>
<div class="menu-content">
    <el-menu :default-active="activeIndex" 
        class="el-menu-demo" 
        background-color="#f1f1f1"
        text-color="#000"
        active-text-color="#f40a0a"
        mode="horizontal" 
        @select="handleSelect">
        <el-menu-item index="1">首页</el-menu-item> 
        <el-menu-item index="3">协会管理</el-menu-item>
        <el-submenu index="4" v-if="adminLimitRoles">
            <template slot="title">新闻管理</template>
            <el-menu-item index="4-1">发布新闻</el-menu-item>
            <el-menu-item index="4-2">新闻查询</el-menu-item>   
        </el-submenu>  
        <el-submenu index="5">
            <template slot="title">赛事管理</template>
            <el-menu-item index="5-1" >赛事查询</el-menu-item>
            <el-menu-item index="5-2" v-if="adminLimitRoles">发布赛事</el-menu-item>  
            <el-menu-item index="5-3" v-if="adminLimitRoles">赛事设置</el-menu-item>
        </el-submenu>       
        <el-menu-item index="6">个人信息</el-menu-item>
        <el-menu-item index="2">信息认证</el-menu-item>
        <el-submenu index="7" v-if="roles">
            <template slot="title">商城管理</template>
            <el-menu-item index="7-1">商品查询</el-menu-item>
            <el-menu-item index="7-2">订单查询</el-menu-item>
            <!-- <el-menu-item index="7-3">物流查询</el-menu-item>    -->
            <el-menu-item index="7-4">商城广告</el-menu-item>  
            <el-menu-item index="7-5">地址查询</el-menu-item> 
        </el-submenu> 
        <el-submenu index="8">
            <template slot="title">培训管理</template>
            <el-menu-item index="8-1" v-if="roles">发布培训</el-menu-item>
            <el-menu-item index="8-2" v-if="roles">培训查询</el-menu-item> 
            <el-menu-item index="8-3" >证书查询</el-menu-item>
        </el-submenu>   
        <el-submenu index="9" v-if="roles">
            <template slot="title">管理员</template>
            <el-menu-item index="9-1">认证审核</el-menu-item>
            <el-menu-item index="9-2">日志查询</el-menu-item>
            <el-menu-item index="9-3">赛事广告</el-menu-item>     
            <el-menu-item index="9-4">合作单位</el-menu-item> 
        </el-submenu>  
    </el-menu>
</div>
</template>

<script>
export default {
    data() {
        return {
            activeIndex: '1',
            menuLinks: {
                '1': '/',
                '2': '/authInfo',
                '3': '/association',
                '4-1': '/newsPage',
                '4-2': '/newsQuery',
                '5': '/playerScoreQuery',
                '5-1': '/playerScoreQuery',
                '5-2': '/publish',
                '5-3': '/newPublishQuery',
                '6': '/userInfo',
                '7-1': '/product',
                '7-2': '/orderQuery',
                '7-4': '/productAdvert',
                '7-5': '/addressQuery',
                '8-1': '/train',
                '8-2': '/trainQuery',
                '8-3': '/traineeQuery',
                '9-1': '/admin',
                '9-2': '/integralLog',
                '9-3': '/advert',   
                '9-4': '/cooperator',            
            }
        }
    },
    created() {

    },
    mounted() {

    },
    computed:{
        roles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        },
        adminLimitRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员' || value === '掼蛋协会' || value === '裁判' || value === '掼蛋俱乐部'){
                return true
            }else{
                return false
            }            
        }
    },
    methods: {
        handleSelect(key,keyPath){
            const url = this.menuLinks[key];
            if (url) {
                this.$router.replace(url);
            }           
        },        
    }
}
</script>
<style lang='scss' scoped>
.menu-content{
    // width: 1000px;
    // height: 50px;
    line-height: 50px;
    background: #f5f5f5;
    // border: 1px solid red;
    border-top: 0;
    margin: 0 auto;
    
}
.el-menu-demo{
    background: #f1f1f1;
    font-size: 20px;
    // height: 50px;
    // line-height: 50px;
}

.el-menu-demo >>> .el-menu--horizontal>.el-menu-item{
    // height: 50px;
    // line-height: 50px;
}
.el-menu-demo >>> .el-menu--horizontal>.el-menu-item .is-active{
    // height: 50px;
    // line-height: 50px;
}
.el-dropdown-link {

}
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue